import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

import {
    COLORS,
    FONT_BODY,
    FONT_TITLE,
    FONTS_HREF,
} from '../storefront/storefrontStyles';

// Marco común de /carrito, /carrito/:storeId y /checkout/:storeId (misma
// estética oscura que la vidriera).
const CartLayout = ({ backTo, backLabel, title, children }) => (
    <Box
        sx={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: COLORS.background,
            color: COLORS.text,
            fontFamily: FONT_BODY,
        }}
    >
        <link href={FONTS_HREF} rel="stylesheet" />
        <Box
            sx={{
                maxWidth: 900,
                mx: 'auto',
                px: { xs: 2, md: 4 },
                py: { xs: 2, md: 4 },
            }}
        >
            {backTo && (
                <Button
                    component={RouterLink}
                    to={backTo}
                    startIcon={<ArrowBackIcon />}
                    sx={{
                        color: COLORS.muted,
                        mb: 2,
                        textTransform: 'none',
                        '&:hover': { color: 'white' },
                    }}
                >
                    {backLabel}
                </Button>
            )}
            {title && (
                <Typography
                    component="h1"
                    sx={{
                        fontFamily: FONT_TITLE,
                        fontWeight: 800,
                        fontSize: { xs: '1.8rem', md: '2.4rem' },
                        textTransform: 'uppercase',
                        letterSpacing: 1,
                        lineHeight: 1.05,
                        mb: 3,
                    }}
                >
                    {title}
                </Typography>
            )}
            {children}
        </Box>
    </Box>
);

export const panelSx = {
    p: { xs: 2, md: 3 },
    borderRadius: '12px',
    backgroundColor: COLORS.surface,
    border: `1px solid ${COLORS.border}`,
};

export const darkAlertSx = {
    backgroundColor: 'rgba(255,255,255,0.04)',
    color: 'white',
    border: `1px solid ${COLORS.border}`,
    '& .MuiAlert-icon': { color: '#f0b429' },
};

export default CartLayout;
